import { useEffect } from "react";
//Other Imports
import RetractableSidebar from "../../home/components/Retractable.Sidebar";
import Link from "admin/shared/ui/Link.Component";
import { savelendConnector } from "../../../services/savelendWithdrawals/connector";
//Redux
import { compose } from "redux";
//Material Ui
import RegisterIcon from "@material-ui/icons/BorderColor";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import IconWithIndicator from "../../home/components/Icon.With.Indicator";
import OrdersIcon from "@material-ui/icons/Reorder";
import { menuOrdersConnector } from "../../../services/orders/menuConnector";

export const SavelendStuffTab = ({
  children,
  fetchOrdersData,
  orders,
  deposit,
  withdraw,
}) => {
  useEffect(() => {
    if (!orders.fetching && !orders.fetched) fetchOrdersData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activeStyle = {
    borderLeft: "#ff9300 4px solid",
    display: "block",
    background: "#f9f9f9",
  };

  const wrapperStyle = {
    display: "flex",
    minHeight: "100%",
  };

  const ordersLen = deposit && withdraw ? deposit.length + withdraw.length : 0;
  const orderList = (
    <IconWithIndicator
      icon={<OrdersIcon />}
      displayIndicator={ordersLen}
      indicator={ordersLen}
    />
  );

  return (
    <div style={wrapperStyle}>
      <RetractableSidebar storageKey="SavelendMoneyTransactions">
        <List>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"orders"}
          >
            <ListItem button>
              <ListItemIcon>{orderList}</ListItemIcon>
              <ListItemText primary="Orders" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"savelendMoneyTransactions"}
          >
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="Withdraw/deposit special" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"referAFriend"}
          >
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="Refer a friend" />
            </ListItem>
          </Link>
          <Link
            activeClassName={"selected"}
            activeStyle={activeStyle}
            toState={"affiliates"}
          >
            <ListItem button>
              <ListItemIcon>
                <RegisterIcon />
              </ListItemIcon>
              <ListItemText primary="Affiliates" />
            </ListItem>
          </Link>
        </List>
      </RetractableSidebar>
      <div
        style={{
          width: "100%",
          boxSizing: "border-box",
          overflow: "auto",
          backgroundColor: "#f9f9f9",
        }}
      >
        <div className="body-height content-padding">{children}</div>
      </div>
    </div>
  );
};

export default compose(
  savelendConnector,
  menuOrdersConnector,
)(SavelendStuffTab);
